/* Progressive enhancement: links and native details work without JavaScript. */
(() => {
  if (window.leniEditorialBound) return;
  window.leniEditorialBound = true;

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lr-mega[open], .lr-mobile-nav[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-leni-scroll]');
    if (control) {
      const rail = document.getElementById(control.getAttribute('aria-controls'));
      if (rail) rail.scrollBy({left: rail.clientWidth * Number(control.dataset.leniScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    document.querySelectorAll('.lr-mega[open], .lr-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.lr-mega[open], .lr-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
